import getTools from '../../tools';
import { WIDGETS_NAMES } from '../../widgets';
import { ChatMessageRole } from '../../widgets/constants';
import { TRANSLATION_KEYS } from '../../constants';
import type {
  AssistantConfig,
  OnCloseEventPayload,
} from '../../aiAssistantTypes';

import { translate } from '#packages/i18n';
import type { EditorAPI } from '#packages/editorAPI';
import { showFeedbackModalIfEnabled } from './feedbackModal';

export const getAssistantConfig = (
  editorAPI: EditorAPI,
  origin: string,
): AssistantConfig => {
  return {
    title: 'Design Assistant',
    assistantName: translate(TRANSLATION_KEYS.PANEL_TITLE),
    domainIds: ['0fb5f482-4e09-441f-9a85-05324e27c9b1'],
    origin,
    tools: getTools({
      editorAPI,
      payloads: { origin: 'theme ai assistant' },
      toolsIds: ['openEditorPanels'],
    }),
    onWidgetAction: () => {},
    theme: 'original',
    firstWidget: {
      role: ChatMessageRole.Assistant,
      widget: WIDGETS_NAMES.OPTION_SELECTOR,
      data: {
        text: translate(TRANSLATION_KEYS.INITIAL_MESSAGE_TEXT),
        buttons: [
          {
            label: translate(
              TRANSLATION_KEYS.INITIAL_MESSAGE_COLORS_SUGGESTION,
            ),
            value: translate(TRANSLATION_KEYS.INITIAL_MESSAGE_COLORS_RESPONSE),
          },
          {
            label: translate(TRANSLATION_KEYS.INITIAL_MESSAGE_FONT_SUGGESTION),
            value: translate(TRANSLATION_KEYS.INITIAL_MESSAGE_FONT_RESPONSE),
          },
          {
            label: translate(TRANSLATION_KEYS.INITIAL_MESSAGE_THEME_SUGGESTION),
            value: translate(TRANSLATION_KEYS.INITIAL_MESSAGE_THEME_RESPONSE),
          },
        ],
      },
    },
    messagePlaceholder: translate(TRANSLATION_KEYS.CHAT_PLACEHOLDER),
    onCloseChat: ({ userMessagesCount }: OnCloseEventPayload) => {
      try {
        showFeedbackModalIfEnabled(editorAPI, userMessagesCount);
      } catch (error) {
        console.log(error);
      }
    },
  };
};
